<div [class.grayed]="grayed">
  <button buttonstyle="flat" [class.grayed]="grayed" (click)="change()" [disabled]="state">{{trueLabel}}</button>
  <button buttonstyle="flat" [class.grayed]="grayed" (click)="change()" [disabled]="!state">{{falseLabel}}</button>
</div>
